import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectWorkspaceIdFragment = { __typename?: 'Project', id: string, workspaceId: string };

export const ProjectWorkspaceId = /*#__PURE__*/ gql`
    fragment ProjectWorkspaceId on Project {
  id
  workspaceId
}
    ` as unknown as DocumentNode<ProjectWorkspaceIdFragment, unknown>;

        

        
export const useProjectWorkspaceIdFragment = (
  input: string | Omit<UseFragmentOptions<ProjectWorkspaceIdFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectWorkspaceIdFragment>({
    fragment: ProjectWorkspaceId,
    fragmentName: 'ProjectWorkspaceId',
    ...options,
  });
};
  
        